import { CSSProperties, memo } from 'react';

import styles from './brandlive-avatar.module.css';

interface IBrandliveAvatar {
  profile: {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    picture?: string | null;
    image?: string | null;
    bg_image?: string | null;
  };
  borderRadius?: CSSProperties['borderRadius'];
}

const BrandliveAvatar = memo((props: IBrandliveAvatar) => {
  const { first_name, last_name, email, picture: _picture, image, bg_image } = props.profile;
  const picture = _picture || image || bg_image;
  const borderRadius = props.borderRadius ?? '100%';

  const getInitials = () => {
    if (first_name || last_name) {
      return `${first_name?.[0] ?? ''}${last_name?.[0] ?? ''}`;
    } else {
      return email?.[0] || '';
    }
  };

  return (
    <div>
      {picture ? (
        <img
          loading="lazy"
          className={`bg-image-cover ${styles['avatar-image']}`}
          src={picture}
          alt={`picture`}
          style={{ borderRadius }}
        />
      ) : (
        <div className={`S2 ${styles['avatar-placeholder']}`} style={{ borderRadius }}>
          {' '}
          {getInitials()}
        </div>
      )}
    </div>
  );
});

BrandliveAvatar.displayName = 'BrandliveAvatar';

export default BrandliveAvatar;
